import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OccEndpointsService } from '@spartacus/core';
import { SendCodeResponse } from '@user/const';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccLoginService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  sendCode(
    phoneNumber: string,
    captchaToken: string | undefined,
    deliveryChannel: string | undefined,
  ): Observable<SendCodeResponse> {
    const url = this.occEndpointsService.buildUrl('/auth/code');

    return this.http.get<SendCodeResponse>(url, {
      params: { phoneNumber, token: captchaToken, deliveryChannel: deliveryChannel },
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, this.occEndpointsService.getRawEndpointValue('/auth/code')),
    });
  }
}
